<template>
  <section class="story03">
        <div class="story03--con">
            <div class="story03--img"></div>
        </div>
  </section>
</template>

<script>
export default {
  name: 'Section3',
};
</script>
